import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { FETCH_IG_HASHTAGS, ACTIVE_BUSINESS_ACCOUNT } from "../actions/instagramHashTagAction";

const igConfigurationReducer = (
    state = {
        igHashTagList: [],
        igHashTagListLoading: false,
        activeBusinessAccounts: [],
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_IG_HASHTAGS):
            return (state = {
                ...state,
                igHashTagListLoading: true,
                igHashTagList: [],
            });
        case isRejected(FETCH_IG_HASHTAGS):
            return (state = {
                ...state,
                igHashTagListLoading: false,
                igHashTagList: [],
            });
        case isFulfilled(FETCH_IG_HASHTAGS):
            return (state = {
                ...state,
                igHashTagListLoading: false,
                igHashTagList: action.payload.result,
            });
        case isFulfilled(ACTIVE_BUSINESS_ACCOUNT):
            return (state = {
                ...state,
                activeBusinessAccounts: action.payload,
            });
        default:
            return state;
    }
};

export default igConfigurationReducer;
